import { c as _c } from "react/compiler-runtime";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import { Button } from "#components/ui/button.jsx";
import termsContent from "../../assets/anvandarvillkor.md?raw";
import { cn } from "../../lib/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FFTermsOfUse(t0) {
  const $ = _c(10);
  const {
    className,
    onBack
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("container mx-auto max-w-3xl px-4 py-6 md:py-10", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onBack) {
    t2 = onBack && /*#__PURE__*/_jsx("div", {
      className: "pb-4",
      children: /*#__PURE__*/_jsxs(Button, {
        className: "inline-flex items-center gap-2",
        variant: "ghost",
        onClick: onBack,
        children: [/*#__PURE__*/_jsx(ArrowLeft, {
          className: "h-4 w-4"
        }), " Tillbaka"]
      })
    });
    $[2] = onBack;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsxs("header", {
      className: "mb-10",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-sm font-medium text-brand uppercase tracking-wide",
        children: "Anv\xE4ndarvillkor"
      }), /*#__PURE__*/_jsx("h1", {
        className: "mt-2 text-3xl md:text-4xl font-bold text-gray-900",
        children: "Anv\xE4ndarvillkor f\xF6r Faster Forward"
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-4 text-gray-600",
        children: "Tr\xE4der i kraft den 14 april 2026"
      })]
    });
    t4 = cn("prose prose-gray max-w-none", "prose-headings:font-bold prose-headings:tracking-tight", "prose-p:leading-relaxed", "prose-a:text-brand prose-a:decoration-brand/40 hover:prose-a:decoration-brand", "prose-strong:font-semibold", "prose-ul:list-disc prose-ol:list-decimal");
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx("article", {
      className: t4,
      children: /*#__PURE__*/_jsx(ReactMarkdown, {
        components: {
          a: _temp
        },
        children: termsContent
      })
    });
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t2) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: t1,
      children: [t2, t3, t5]
    });
    $[7] = t1;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(t0) {
  const {
    ...props
  } = t0;
  return /*#__PURE__*/_jsx("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    ...props
  });
}